/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import React, { useState } from "react";
import Heading from "../../components/Heading";
import "./style.scss";
import UndeliveredShipmentsList from "./UndeliveredShipmentsList";
import RTORequestsList from "./RTORequestsList";
import { Tabs } from "antd";

const UndeliveredShipments = () => {
  const [activeKey, setActiveKey] = useState("1");
  const [tabValue, setTabValue] = useState("undelivered");
  
  const onChange = (key) => {
    setActiveKey(key);
    setTabValue(key === "1" ? "undelivered" : "rto");
  };

  return (
    <div className="p-1">
      <Heading title="Undelivered Shipments" />
      <div className="global-card-tab-container">
        <Tabs
          defaultActiveKey="1"
          activeKey={activeKey}
          onChange={onChange}
          items={[
            {
              label: "Undelivered",
              key: "1",
              children: <UndeliveredShipmentsList tabValue={tabValue} />,
            },
            {
              label: "Requests for RTO",
              key: "2",
              children: <RTORequestsList tabValue={tabValue} />,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default UndeliveredShipments; 
